/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DecodedUserToken } from './DecodedUserToken';
import {
    DecodedUserTokenFromJSON,
    DecodedUserTokenFromJSONTyped,
    DecodedUserTokenToJSON,
} from './DecodedUserToken';

/**
 * 
 * @export
 * @interface VerifyToken
 */
export interface VerifyToken {
    /**
     * 
     * @type {DecodedUserToken}
     * @memberof VerifyToken
     */
    data?: DecodedUserToken;
}

/**
 * Check if a given object implements the VerifyToken interface.
 */
export function instanceOfVerifyToken(value: object): value is VerifyToken {
    let isInstance = true;

    return isInstance;
}

export function VerifyTokenFromJSON(json: any): VerifyToken {
    return VerifyTokenFromJSONTyped(json, false);
}

export function VerifyTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DecodedUserTokenFromJSON(json['data']),
    };
}

export function VerifyTokenToJSON(value?: VerifyToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DecodedUserTokenToJSON(value.data),
    };
}

